import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { goToDeepLink } from '../../utils/utilsFunctions';

import { StepWrapperBox } from '../styledComponent/Boxes.style';

import { BaseStep, StepProps, StepWizardProps, TitleAndDescriptionProps } from '../common/BaseStep';
import { SecondaryTitleDescription } from '../common/SecondaryTitleDescription';

interface StyleProps {
  isLastCard: boolean;
}

const ProductCard = styled.div`
  padding-bottom: 32px;
  margin-bottom: ${(props: StyleProps) => (props.isLastCard ? 0 : '16px')};
`;
const Img = styled.img`
  height: 311px;
  width: 311px;
  width: 100%;
  border-radius: 24px;
  object-fit: cover;
`;

export interface RedirectLinks {
  desktopLink: string;
  mobileLink: string;
  isAppsflyer?: boolean;
  androidPlayStoreUrl?: string;
  iosAppStoreUrl?: string;
}

interface FinishSignUpStepProps extends TitleAndDescriptionProps, StepWizardProps, StepProps, RedirectLinks {
  productsInformation: {
    title: string;
    description: string;
    imageUrl: string;
  }[];
}

export const FinishSignUpStep = (props: FinishSignUpStepProps) => {
  const { productsInformation, desktopLink, mobileLink, isActive, isAppsflyer = false } = props;

  useEffect(() => {
    if (isActive) return window.scrollTo(0, 0);
  }, [isActive]);

  return (
    <>
      {isActive ? (
        <BaseStep {...props} changeButtonFunction={() => goToDeepLink({ mobileLink, desktopLink, isAppsflyer })}>
          <StepWrapperBox>
            {productsInformation.map((productInformation, index) => {
              return (
                <ProductCard key={productInformation.title} isLastCard={index + 1 === productsInformation.length}>
                  <SecondaryTitleDescription {...productInformation} />
                  <Img src={productInformation.imageUrl} />
                </ProductCard>
              );
            })}
          </StepWrapperBox>
        </BaseStep>
      ) : (
        ''
      )}
    </>
  );
};
